import { Box } from 'common';
import { AdsComponent } from 'components/Ads';
import { NewsComponent } from 'components/News';
import { PromoComponent } from 'components/Promo';
import { SliderComponent } from 'components/Slider';

import { Helmet } from 'react-helmet';

export const HomePage = () => {
    return (
        <Box>
            <Helmet>
                <title>Главная - AlmaU Open Library</title>
                <meta name="description" content="Главная страница библиотеки AlmaU Open Library" />
            </Helmet>

            <PromoComponent />
            <SliderComponent />
            <NewsComponent />
            <AdsComponent />
        </Box>
    );
};
    